module.exports = __webpack_public_path__ + "img/icon6.1610a2e9.png";